export default () => {

  const buttons = document.querySelectorAll('button[data-job]');
  const jobId = document.querySelector('#Form_ApplicationForm_JobPost');
  const jobTitle = document.querySelector('#Form_ApplicationForm_Position');
  const application = document.querySelector('.careersPage__application');

  for (const btn of buttons) {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      jobTitle.value = e.target.getAttribute('data-title');
      jobId.value = e.target.getAttribute('data-job');
      application.scrollIntoView({ behavior: 'smooth' });
    });
  }

}
